import isRequestSignaturePopup from './isRequestSignaturePopup';

export default popup => isRequestSignaturePopup(popup) && popup.requestType === 'sign';



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isRequestSignatureSignPopup.jsx